import { Head, Link, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface VendorTypeGroup {
  id: number
  name: string
  status: number
  usage_count: number
}

interface Props {
  vendor_type_groups: VendorTypeGroup[]
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Manage", href: "/admin/vendor_type_groups" },
  { title: "Vendor Type Groups", href: "/admin/vendor_type_groups" },
]

export default function Index({ vendor_type_groups }: Props) {
  const handleDelete = (id: number, usageCount: number) => {
    const message =
      usageCount > 0
        ? "This group is in use. It will be deactivated instead of deleted. Continue?"
        : "Are you sure you want to delete this group?"

    if (confirm(message)) {
      router.delete(`/admin/vendor_type_groups/${id}`)
    }
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Vendor Type Groups" />

      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">Vendor Type Groups</h1>
          <Link
            href="/admin/vendor_type_groups/new"
            className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white"
          >
            Add Group
          </Link>
        </div>

        {vendor_type_groups.length > 0 ? (
          <table className="border-hpi-light-gray w-full border-collapse border">
            <thead>
              <tr className="bg-hpi-pale-gray">
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  ID
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Name
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  In Use
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {vendor_type_groups.map((vtg) => (
                <tr key={vtg.id} className="hover:bg-hpi-pale-blue">
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {vtg.id}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {vtg.name}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {vtg.usage_count > 0 ? vtg.usage_count : ""}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    <Link
                      href={`/admin/vendor_type_groups/${vtg.id}/edit`}
                      className="text-hpi-active-blue mr-2 hover:underline"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => handleDelete(vtg.id, vtg.usage_count)}
                      className="text-hpi-red hover:underline"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-hpi-med-gray">No vendor type groups found.</p>
        )}
      </div>
    </AppLayout>
  )
}
